import { instance } from '@/services/avik-api-gateway'
import { VehicleTypePeriod } from '@/types/vehicle-type-period'
import { AxiosResponse } from 'axios'

export function getVehicleTypesPeriod(): Promise<
  AxiosResponse<VehicleTypePeriod[]>
> {
  return instance.get(`/vehicle-type-period`)
}
